<h3>Calendário de Feriados</h3>

<div class="row mb-2">
  <div class="col-6">
    <form #thisForm="ngForm" (ngSubmit)="getFromGateway()">
      <div class="card mt-3">
        <div class="card-header text-uppercase">
          <span>Obter da Internet</span>
        </div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-12">
              <label>Ano*</label>
              <input
                type="number"
                data-cy="year"
                class="form-control"
                name="year"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="requestModel.year"
                required
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <label>Tipos de Feriados*</label>
              <ng-select
                [multiple]="true"
                [closeOnSelect]="false"
                [clearSearchOnAdd]="true"
                [items]="holidayTypeList"
                bindLabel="description"
                bindValue="name"
                notFoundText="Selecione um tipo de feriado para continuar..."
                [(ngModel)]="requestModel.types"
                [ngModelOptions]="{ standalone: true }"
                required
              >
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-item$="item$"
                  let-index="index"
                >
                  <input
                    id="item-{{ index }}"
                    type="checkbox"
                    [ngModel]="item$.selected"
                    [ngModelOptions]="{ standalone: true }"
                    name="typesSelected-{{ index }}"
                  />
                  {{ item.description }}
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <div class="actions">
        <input
          type="button"
          [disabled]="getFromGatewayButtonDisabled()"
          value="Obter Feriados"
          class="btn btn-primary"
          appDebounceClick
          (debounceClick)="getFromGateway()"
          [debounceTime]="200"
        />
      </div>
    </form>
  </div>

  <div class="col-6">
    <form #thisForm="ngForm" (ngSubmit)="registerHoliday()">
      <div class="card mt-3">
        <div class="card-header text-uppercase">
          <span>Cadastrar Manualmente</span>
        </div>
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-12">
              <label>Data*</label>
              <input
                type="date"
                data-cy="newDate"
                class="form-control"
                name="newDate"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="registerHolidayModel.date"
                required
              />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-6">
              <label>Nome*</label>
              <input
                type="text"
                data-cy="newName"
                class="form-control"
                name="newName"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="registerHolidayModel.description"
                required
              />
            </div>
            <div class="col-6">
              <label>Tipo*</label>
              <mat-select
                data-cy="holidayType"
                class="form-control"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="registerHolidayModel.typeName"
                required
              >
                <mat-option
                  *ngFor="let item of holidayTypeList"
                  name="holidayType"
                  [value]="item.name"
                >
                  {{ item.description }}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
      </div>

      <div class="actions">
        <input
          type="button"
          [disabled]="registerHolidayButtonDisabled()"
          value="Cadastrar"
          class="btn btn-primary"
          appDebounceClick
          (debounceClick)="registerHoliday()"
          [debounceTime]="200"
        />
      </div>
    </form>
  </div>
</div>

<div>
  <table
    *ngIf="holidayList && holidayList.length > 0"
    class="table table-striped table-hover"
  >
    <thead class="thead-dark">
      <tr>
        <th scope="col">Data</th>
        <th scope="col">Descrição</th>
        <th scope="col">Tipo</th>
        <th scope="col">Excluir</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of holidayList">
        <td>{{ item.date | date: "dd/MM/yyyy":"GMT" }}</td>
        <td>{{ item.description }}</td>
        <td>{{ item.typeDescription }}</td>
        <td>
          <button
            mat-raised-button
            color="primary"
            (click)="deleteHoliday(item.id)"
          >
            Excluir
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
